const SET_IMAGE = 'https://static.lumi.new/b7/b72bf0042eca9ccda905e2f82e574d60.webp'
const FALLING_IMAGE = 'https://static.lumi.new/42/4266c30fc26d1c68dda7e926d76c0224.webp'
const NEVER_IMAGE = 'https://static.lumi.new/22/22228db10f62b66d481d27b904289b00.webp'

const scents = [
  {
    name: 'Falling in Love',
    tagline: '溫柔墜入，甜而不膩',
    description:
      '〈Falling in Love〉是一場清醒地走進愛裡的旅程，從晨光般的柑橘瓜果與柔和花香中勇敢靠近，最終在琥珀麝香與蜜桃草莓的甜美底蘊裡，將怦然心動化為長久的溫柔陪伴。',
    tags: ['甜美', '浪漫'],
    accent: 'rose' as const,
    image: FALLING_IMAGE,
    imageAlt: 'Falling in Love 香氛瓶身與包裝',
  },
  {
    name: 'Never Cared',
    tagline: '冷感疏離，個性鮮明',
    description:
      '〈Never Cared〉是一段從壓抑與被忽略中醒來的自我重生歷程；透過冷冽辛香開啟撕裂後的清醒，並在沉靜木質與琥珀的包圍下，允許悲傷沉澱，最終勇敢地將自己迎接收回——「我依然是我」。',
    tags: ['冷感', '個性'],
    accent: 'amber' as const,
    image: NEVER_IMAGE,
    imageAlt: 'Never Cared 香氛瓶身與包裝',
  },
]

function ProductHighlights() {
  return (
    <section id="highlights" className="bg-stone-50 py-10 sm:py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
        <div className="max-w-2xl mb-8 sm:mb-14 lg:mb-20">
          <p className="text-xs tracking-[0.3em] text-slate-500 mb-3 sm:mb-4">PRODUCT HIGHLIGHTS</p>
          <h2 className="font-serif text-[21px] sm:text-3xl lg:text-4xl text-zinc-900 mb-3 sm:mb-4">香氛特色與香調介紹</h2>
          <p className="text-zinc-500 text-sm lg:text-base leading-[1.6]">
            兩款不同氛圍的香氛，組成專屬於你的情緒語彙。每支 10ml，隨身攜帶，隨心切換。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 sm:gap-8 mb-8 sm:mb-16">
          {scents.map(scent => (
            <div
              key={scent.name}
              className={`relative w-full p-5 sm:p-8 lg:p-10 bg-white border ${scent.accent === 'rose' ? 'border-rose-200' : 'border-amber-900/20'} rounded-sm`}
            >
              <div
                className="flex flex-row items-center justify-between gap-4 mb-5 sm:mb-6"
              >
                <span
                  className={`inline-block w-10 h-10 shrink-0 rounded-full ${scent.accent === 'rose' ? 'bg-rose-300' : 'bg-amber-800'}`}
                />
                <img
                  src={scent.image}
                  alt={scent.imageAlt}
                  className="h-auto w-auto shrink-0 object-contain"
                  style={{ maxWidth: '120px', height: 'auto' }}
                />
              </div>
              <h3 className="font-serif text-xl sm:text-2xl text-zinc-900 mb-1">{scent.name}</h3>
              <p className={`text-sm mb-4 sm:mb-5 ${scent.accent === 'rose' ? 'text-rose-500' : 'text-amber-800'}`}>{scent.tagline}</p>
              <p className="text-zinc-500 text-sm leading-[1.6] mb-5 sm:mb-6">{scent.description}</p>
              <div className="flex flex-wrap gap-2">
                {scent.tags.map(tag => (
                  <span key={tag} className="text-xs px-3 py-1 bg-zinc-100 text-zinc-600 rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-6 sm:gap-10 items-center bg-white border border-zinc-200 rounded-sm overflow-hidden">
          <img
            src={SET_IMAGE}
            alt="The Taste Of... 香氛組合產品主視覺"
            className="w-full h-auto object-contain p-5 sm:p-6 lg:p-10"
          />
          <div className="p-5 sm:p-8 lg:p-10 lg:pr-14">
            <h3 className="font-serif text-lg sm:text-xl lg:text-2xl font-bold text-zinc-900 mb-5 sm:mb-6">《The Taste Of... 香氛組合》</h3>
            <p className="text-zinc-800 text-sm font-bold leading-[1.8] mb-5">愛情的滋味從不只有一種樣貌。</p>
            <p className="text-zinc-500 text-sm leading-[1.8] mb-3">
              〈Never Cared〉 是一次向內的醒悟與重生，陪伴你在沉澱後勇敢地說出：「我還是我」。
            </p>
            <p className="text-zinc-500 text-sm leading-[1.8] mb-6">
              〈Falling in Love〉 則是一場向外的擁抱與傾心。清醒而堅定地走進溫柔依戀的每一刻。
            </p>
            <p className="text-zinc-800 text-sm font-bold leading-[1.8] mb-2">先找回自己，再溫柔相愛</p>
            <p className="text-zinc-800 text-sm font-bold leading-[1.8]">這是一份獻給靈魂最完整的情書。</p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductHighlights
